<!-- 学校-课程评价管理 -->
<template>
<div>
    <div class="index">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
			<div class="Homeboxtop_nav_tab">
			<span
				v-for="(item, index) in tabList"
				:class="['res-tab', { active: item.name === tabName }]"
				:key="index"
				@click="tabClick(item)"
			>
				{{ item.name }}
			</span>
			</div>
        </div>

        <div>
            <el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="" label-width="40px">
                    <el-select v-model="queryParams.star" clearable placeholder="选择星级" class="label">
                        <el-option v-for="item in starList" :key="item.id+'rating'" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
                    <el-input type="text" placeholder="请输入课程名称" v-model="queryParams.cname"></el-input>
                </el-form-item>
				<el-form-item label="">
                    <el-input type="text" placeholder="请输入评价关键字" v-model="queryParams.comments"></el-input>
                </el-form-item>
				<el-form-item label="">
					<el-date-picker v-model="queryParams.date" type="daterange" style="width: 240px;" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" >
					</el-date-picker>
				</el-form-item>
                
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
            </el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
					<el-table-column prop="cname" label="评价课程" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="evalUsername" label="评价人" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="evalUsertype" label="身份" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<p>{{userType[scope.row.evalUsertype]}}</p>
						</template>
                    </el-table-column>
                    
                    <el-table-column prop="evalUserClassname" label="班级" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="rating" label="评价星级" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<p>{{scope.row.rating}}星</p>
						</template>
                    </el-table-column>
					<el-table-column prop="content" label="评价内容" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="evalTime" label="评价时间" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<p>{{dayjs(scope.row.evalTime).format('YYYY-MM-DD HH:mm')}}</p>
						</template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" fixed="right" v-if="tabName!=='审核不通过'">
                        <template slot-scope="scope">
                            <el-button v-if="tabName==='待审核'" type="text" size="small" @click="pass(scope.row)">通过</el-button>
							<el-button v-if="tabName==='待审核'" type="text" size="small" @click="reject(scope.row)" style="margin-left:10px">不通过</el-button>
							<el-button v-if="tabName==='审核通过'" type="text" size="small" @click="hiddenItem(scope.row)">屏蔽</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize" :total="queryParams.totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import schoolApi from '@/api/schoolApi/index.js';
import dayjs from 'dayjs';
import util from '@/utils/util.js';
export default {
    components:{
        
    },
	data() {
		return {
			queryParams: {
				cname: '',
				comments:'',
				star: '',
				date:'',
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
			},
			starList: [
				{id:1,label:'1星'},
				{id:2,label:'2星'},
				{id:3,label:'3星'},
				{id:4,label:'4星'},
				{id:5,label:'5星'},
			],
			tableData: [],
			tabList: [{ name: "待审核" }, { name: "审核通过" }, { name: "审核不通过" }],
			tabName:'待审核',
			tabObj:{
				'待审核':0,
				'审核通过':1,
				'审核不通过':2
			},
			userType:{
				'0':'学生',
				'1':'老师',
				'2':'家长',
			},
		}
	},
	watch:{
		tabName(n,o){
			this.searchFun();
		}
	},
	created() {
		this.getDataList();
	},
	methods: {
		dayjs,
		async getDataList() {
			let that=this.queryParams;
			let state=this.tabObj[this.tabName];
			let obj={};
			if(that.date){
				obj.startTime=dayjs(that.date[0]).format('YYYY-MM-DD');
				obj.endTime=dayjs(that.date[1]).format('YYYY-MM-DD');
			}
			if(that.cname){
				obj.cnameKey=that.cname;
			}
			if(that.comments){
				obj.contentKey=that.comments;
			}
			if(that.star){
				obj.rating=that.star;
			}
			let params = {
				pageNum:that.pageNum,
				pageSize:that.pageSize,
				status:state,
			}
			params={...params,...obj};
			let {result, data} = await schoolApi.schoolCourseEvaluateList(params);
			if(result==='000000'){
				this.tableData=data.list || [];
				that.totalPage=data.total || 0;
			}
		},
		searchFun(){
			this.queryParams.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.queryParams.pageSize = val;
			this.getDataList();
		},
		currentChangeHandle(val) {
			this.queryParams.pageNum = val;
			this.getDataList();
		},
		async pass(item){
			try{
				// util.handleCofirm('确定通过?', 'info',).then(async res => {
				// })
				let params={
					ids:[item.id],
				}
				let {result, data} = await schoolApi.schoolCourseEvaluatePass(params);
				if(result==='000000'){
					this.$message.success('操作成功');
					this.getDataList();
				}else{
					his.$message.error('操作失败');
				}
			}catch(err){
				console.log(err);
			}
		},
		async reject(item){
			try{
				// util.handleCofirm('确定不通过?', 'info',).then(async res => {
				// })
				let params={
					ids:[item.id],
				}
				let {result, data} = await schoolApi.schoolCourseEvaluateFailed(params);
				if(result==='000000'){
					this.$message.success('操作成功');
					this.getDataList();
				}else{
					his.$message.error('操作失败');
				}
			}catch(err){
				console.log(err);
			}
		},
		tabClick(item) {
			this.tabName = item.name;
		},
		async hiddenItem(item){
			try{
				util.handleCofirm('该评价屏蔽后将变更为审核不通过\n请您确认?', 'info',).then(async res => {
					let params={
						ids:[item.id],
					}
					let {result, data} = await schoolApi.schoolCourseEvaluateFailed(params);
					if(result==='000000'){
						this.$message.success('操作成功');
						this.getDataList();
					}else{
						his.$message.error('操作失败');
					}
				})
			}catch(err){
				console.log(err);
			}
		},
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}

}
.confirm{
	.content{
		width: 100%;
		padding: 0 15px 15px;
		text-align: center;
	}
}
</style>
